package org.matthewo

import web.dom.document
import web.events.Event
import web.events.EventType
import web.events.addEventListener
import web.window.window
import kotlin.time.Clock
import kotlin.time.Duration.Companion.hours
import kotlin.time.Duration.Companion.seconds
import kotlin.time.Instant

// how long the page can be away before coming back reloads it; nobody's in the middle of anything after this long
private val RELOAD_AFTER = 1.hours

/**
 * Whether a page hidden at [hiddenAt], or never hidden if null, should reload now that it's shown again at [now].
 */
internal fun reloadsOnReturn(hiddenAt: Instant?, now: Instant) = null != hiddenAt && now - hiddenAt >= RELOAD_AFTER

/**
 * Reloads the page when it's shown again after [RELOAD_AFTER] away, for a new version and fresh data. An app on a
 * phone's home screen is only paused when it's left, so without this it keeps running the version it was opened with
 * until it's closed for good.
 */
fun reloadAfterAway(clock: Clock = Clock.System) {
    // the wall clock, since the steady one may not count the time a phone was asleep
    var hiddenAt: Instant? = if (document.hidden) clock.now() else null
    document.addEventListener(EventType("visibilitychange"), { _: Event ->
        val now = clock.now()
        when {
            document.hidden -> hiddenAt = now
            reloadsOnReturn(hiddenAt, now) -> window.location.reload()
            else -> hiddenAt = null
        }
    })
}
